const LS_VOTES = 'fg_fund_poll_votes';

function readVotes() {
    try {
        return JSON.parse(localStorage.getItem(LS_VOTES) || '{}');
    } catch {
        return {};
    }
}

function writeVotes(data) {
    localStorage.setItem(LS_VOTES, JSON.stringify(data));
}

export function createPollFromForm(question, optionsRaw) {
    const options = optionsRaw
        .map((o) => String(o).trim())
        .filter(Boolean)
        .slice(0, 4);
    if (!question?.trim() || options.length < 2) return null;
    return {
        id: `poll-${Date.now()}`,
        question: question.trim(),
        options,
    };
}

export function getPollVoteKey(campaignId, updateId) {
    return `${campaignId}:${updateId}`;
}

export function hasVoted(campaignId, updateId, email) {
    const key = getPollVoteKey(campaignId, updateId);
    const votes = readVotes();
    return (votes[key] || []).some((v) => v.email === email.toLowerCase());
}

export function recordLocalVote(campaignId, updateId, email, optionIndex) {
    const key = getPollVoteKey(campaignId, updateId);
    const votes = readVotes();
    const list = votes[key] || [];
    if (list.some((v) => v.email === email.toLowerCase())) return false;
    list.push({ email: email.toLowerCase(), optionIndex, at: Date.now() });
    votes[key] = list;
    writeVotes(votes);
    return true;
}

export function getVoteCounts(poll, campaignId, updateId) {
    const key = getPollVoteKey(campaignId, updateId);
    const votes = readVotes()[key] || [];
    const counts = poll.options.map(() => 0);
    votes.forEach((v) => {
        if (v.optionIndex >= 0 && v.optionIndex < counts.length) {
            counts[v.optionIndex] += 1;
        }
    });
    return counts;
}

export function renderPollHtml(poll, campaignId, updateId, fund, voterEmail = '') {
    if (!poll?.options?.length) return '';
    const counts = getVoteCounts(poll, campaignId, updateId);
    const total = counts.reduce((a, b) => a + b, 0) || 1;
    const voted = voterEmail && hasVoted(campaignId, updateId, voterEmail);

    if (voted) {
        const bars = poll.options.map((opt, i) => {
            const pct = Math.round((counts[i] / total) * 100);
            return `<div class="fg-fund-poll__result">
                <span>${escapeHtml(opt)}</span>
                <div class="fg-fund-poll__bar"><div style="width:${pct}%"></div></div>
                <strong>${pct}%</strong>
            </div>`;
        }).join('');
        return `<div class="fg-fund-poll fg-fund-poll--results"><p class="fg-fund-poll__q">${escapeHtml(poll.question)}</p>${bars}</div>`;
    }

    const opts = poll.options.map((opt, i) => `
        <button type="button" class="fg-fund-poll__opt" data-poll-update="${updateId}" data-poll-opt="${i}">${escapeHtml(opt)}</button>
    `).join('');

    return `<div class="fg-fund-poll" data-update-id="${updateId}">
        <p class="fg-fund-poll__q">${escapeHtml(poll.question)}</p>
        <div class="fg-fund-poll__opts">${opts}</div>
        <div class="fg-fund-poll__vote-email">
            <input type="email" class="fg-input fg-poll-email" placeholder="Email to vote" value="${voterEmail || ''}">
        </div>
    </div>`;
}

export function renderPollResultsDashboard(updates, campaignId, fund) {
    const withPolls = (updates || []).filter((u) => u.poll?.options?.length);
    if (!withPolls.length) {
        return `<p class="fg-fund-empty-sub">${fund.tr('noPollsYet')}</p>`;
    }
    return withPolls.map((u) => {
        const counts = getVoteCounts(u.poll, campaignId, u.id);
        const total = counts.reduce((a, b) => a + b, 0) || 1;
        const bars = u.poll.options.map((opt, i) => {
            const pct = Math.round((counts[i] / total) * 100);
            return `<div class="fg-fund-poll__result">
                <span>${escapeHtml(opt)}</span>
                <div class="fg-fund-poll__bar"><div style="width:${pct}%"></div></div>
                <strong>${counts[i]} (${pct}%)</strong>
            </div>`;
        }).join('');
        return `<div class="fg-fund-poll-dashboard-card">
            <h4>${escapeHtml(u.title)}</h4>
            <p class="fg-fund-poll__q">${escapeHtml(u.poll.question)}</p>
            ${bars}
            <span class="fg-fund-poll-dashboard-card__total">${total} vote(s)</span>
        </div>`;
    }).join('');
}

function escapeHtml(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
